/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Mock_Time_BotInputs */

const tr_landing_community_mock_time_bot = /** @type {(inputs: Landing_Community_Mock_Time_BotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7dk`)
};

const en_landing_community_mock_time_bot = /** @type {(inputs: Landing_Community_Mock_Time_BotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7m`)
};

const de_landing_community_mock_time_bot = /** @type {(inputs: Landing_Community_Mock_Time_BotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 Min`)
};

const ru_landing_community_mock_time_bot = /** @type {(inputs: Landing_Community_Mock_Time_BotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 мин`)
};

/**
* | output |
* | --- |
* | "7m" |
*
* @param {Landing_Community_Mock_Time_BotInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_mock_time_bot = /** @type {((inputs?: Landing_Community_Mock_Time_BotInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Mock_Time_BotInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_mock_time_bot(inputs)
	if (locale === "de") return de_landing_community_mock_time_bot(inputs)
	if (locale === "ru") return ru_landing_community_mock_time_bot(inputs)
	return tr_landing_community_mock_time_bot(inputs)
});